module.exports = "/_next/static/images/CreateSingleViewOfTheCustomer@2x-ff1a6158167b66564fe238f3f6d99093.png";